module.exports = __webpack_public_path__ + "static/img/questionnaire.ea056859.png";